import {debounce} from 'throttle-debounce';
import {setQueryParam, deleteQueryParam} from 'src/utils/url';

class QuoteControl {
  constructor() {
    this.handleQCColorChange = this.handleQCColorChange.bind(this);
    this.qcFromInput = '.pc-QuoteControl-form-input';
    this.initBehavior();
  }

  // Private

  initBehavior() {
    $(document).on(
      'input',
      `${this.qcFromInput}#ord_qty`,
      debounce(500, this.handleQCQtyChange)
    );
    $(document).on(
      'input',
      `${this.qcFromInput}#quote_fc, ${this.qcFromInput}#quote_bc`,
      debounce(500, this.handleQCColorChange)
    );
  }

  handleQCQtyChange(e) {
    const value = e.currentTarget.value;
    const query = 'min_order_qty[]';
    if (value !== null && value.length > 0) {
      const url = setQueryParam(query, value);
      history.pushState({}, null, url);
      ProductCatalog.Listing.fetchStylesXhr(url, function () {
        $(document).trigger('updated.quotecontrol.qty');
      });
    }
  }

  // Private (event handlers)
  handleQCColorChange(e) {
    $(document).trigger('updated.quotecontrol.colors');
    let url;
    const query = e.currentTarget.id;
    const value = e.currentTarget.value;
    if (value !== null && value.length > 0) {
      url = setQueryParam(query, value);
    } else {
      url = deleteQueryParam(query);
    }
    history.pushState({}, null, url);
    this.updateCatalogLinks(query, value);
  }

  updateCatalogLinks(query, value) {
    $('a').each((id, element) => {
      const $link = $(element);
      let linkUrl = $link.attr('href');
      if (linkUrl !== undefined && linkUrl.indexOf('/products') !== -1) {
        if (value !== null && value.length > 0) {
          linkUrl = setQueryParam(query, value, linkUrl);
        } else {
          linkUrl = deleteQueryParam(query, linkUrl);
        }
        $link.attr('href', linkUrl);
      }
    });
  }
}

jQuery(() => (ProductCatalog.QuoteControl = new QuoteControl()));
